import { defineComponent } from 'vue';
import ShareResultButton from '@/components/ViewResultCard/ShareResultButton/ShareResultButton.vue';
import { ExamResultInterface } from '@/constants/ExamResultsHiv';
import netflixLogo from '@/assets/covid/netflix-new-icon.png';
import GoogleAnalyticsEvents from '@/helpers/GoogleAnalyticsEvents';
import { mapState } from 'pinia';
import { useRegisterTestStore } from '@/store/RegisterTestStore';

export default defineComponent({
  props: {
    resultInfos: {
      type: Object as () => ExamResultInterface,
    },
  },
  components: {
    ShareResultButton,
  },
  computed: {
    ...mapState(useRegisterTestStore, ['patient']),
  },
  data() {
    return {
      currentSlide: 0,
      firstSlideDrag: 0,
      urlLogoNetflix: netflixLogo,
    };
  },
  methods: {
    changeSlide(event: any) {
      if (this.firstSlideDrag === 0 && event.currentSlide === 1) {
        GoogleAnalyticsEvents.firstSlideDrag();
        this.firstSlideDrag++;
      }
      this.currentSlide = event.currentSlide;
    },
    clickNetflix() {
      GoogleAnalyticsEvents.clickNetflixLink();
    },
  },
});
